import { createI18n } from 'vue-i18n';
import { boot } from 'quasar/wrappers';
import { useTranslationsStore } from 'stores/translations-store';

// Create I18n instance
const i18n = createI18n({
  locale: 'en',
  legacy: false,
  missing: () => '', // Return empty space for missing keys.
  messages: {},
});

export default boot(({ app }): void => {
  // Fetch translations from server and add dynamically.
  const translationsStore = useTranslationsStore();
  translationsStore.getTranslations().then(function (translations = {}) {
    i18n.global.setLocaleMessage('en', translations);
  });

  // Tell app to use the I18n instance & expose global property $t.
  app.use(i18n);
  app.config.globalProperties.$t = i18n.global.t;
});

export { i18n };
